import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import PaperIcon from './PaperIcon'
import Tooltip from './Tooltip'

const styles = theme => ({
  container: {
    marginBottom: '20px'
  }
})

const LogoutButton = ({ classes, onClick, username }) => (
  <PaperIcon className={classes.container} style={{ marginBottom: '20px' }}>
    <Tooltip id={'logout'} title={`sign out ${username}`}>
      <IconButton color='primary' onClick={() => onClick()}>
        <AccountCircleIcon />
      </IconButton>
    </Tooltip>
  </PaperIcon>
)

export default withStyles(styles)(LogoutButton)



// WEBPACK FOOTER //
// ./src/components/LogoutButton.js